export default {
    delete_unittype_title: "Eliminar los tipos de unidades",
    delete_unittype_success_message: "Se ha eliminado el tipo de unidad",
    delete_unittype_error_message: "No ha sido posible eliminar el tipo de unidad",
    delete_unittype_label: "¿Está seguro de que quiere eliminar el tipo de unidad?",
    delete_unittype_in_use: "El tipo de unidad está vinculado a algunos modelos de dispositivo, por lo que no es posible eliminarlo"
}